import axios from 'axios';

const api = axios.create({
  baseURL: 'https://4sightoperations.in/',
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      // Adjust the prefix based on your backend (DRF TokenAuthentication uses "Token")
      config.headers.Authorization = `Token ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
